/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ integration: NonNullable<unknown> }} Rights_Tools_All_Connections_DescriptionInputs */



/**
* | output |
* | --- |
* | "This setting applies to ALL of this user's {integration} connections — including their own, which you cannot see." |
*
* @param {Rights_Tools_All_Connections_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_all_connections_description = /** @type {((inputs: Rights_Tools_All_Connections_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_All_Connections_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Diese Einstellung gilt für ALLE ${i?.integration}-Verbindungen dieses Nutzers – auch für seine eigenen, die Sie nicht sehen können.`)
	return /** @type {LocalizedString} */ (`This setting applies to ALL of this user's ${i?.integration} connections — including their own, which you cannot see.`)
});